import { useState, useEffect, useCallback } from 'react';
import { Fab, Box, Fade } from '@mui/material';
import { useLocales } from '../locales';

// Debounce utility function
const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

// Check visibility function moved outside component
const checkVisibility = (setIsVisible) => {
    const ticketsContainer = document.getElementById('tickets-or-seats-container');
    if (!ticketsContainer) {
        setIsVisible(false);
        return;
    }

    const rect = ticketsContainer.getBoundingClientRect();
    const isInView = rect.top < window.innerHeight && rect.bottom > 0;
    setIsVisible(!isInView);
};

export const EventPageFAB = ({ event }) => {
    const { translate } = useLocales()
    const [isVisible, setIsVisible] = useState(false);

    // Debounced version of checkVisibility
    const debouncedCheckVisibility = useCallback(
        debounce(() => checkVisibility(setIsVisible), 100),
        []
    );

    useEffect(() => {
        // Check on mount
        checkVisibility(setIsVisible);

        // Add event listeners with debounced function
        window.addEventListener('scroll', debouncedCheckVisibility);
        window.addEventListener('resize', debouncedCheckVisibility);

        return () => {
            window.removeEventListener('scroll', debouncedCheckVisibility);
            window.removeEventListener('resize', debouncedCheckVisibility);
        };
    }, [debouncedCheckVisibility]);

    const handleClick = () => {
        const ticketsContainer = document.getElementById('tickets-or-seats-container');
        if (ticketsContainer) {
            ticketsContainer.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    let text = ''
    if (event.FAB_text) {
        text = event.FAB_text
    } else if (event.isSeatsEvent) {
        text = translate('event_page.go_to_seats_selection')
    } else {
        text = translate('event_page.go_to_tickets_selection')
    }

    return (
        <div style={{ position: 'fixed', bottom: '5%', right: '5%', zIndex: 1000 }}>
            <Fade in={isVisible} timeout={300}>
                <Box>
                    <Fab
                        variant="extended"
                        color="primary"
                        onClick={handleClick}
                        sx={{
                            borderRadius: '50px',
                            p: '1.5rem',
                            fontSize: '1.2rem',
                            boxShadow: 3,
                            '&:hover': {
                                boxShadow: 6,
                            },
                        }}
                    >
                        {text}
                    </Fab>
                </Box>
            </Fade>
        </div>
    );
}; 